/**
 * Deterministic decorative sparkline (no historical series in L1).
 * @param {number} instrumentId
 * @param {boolean} positiveTrend visually bias line direction
 * @returns {string} space-separated "x,y" pairs for SVG polyline / polygon top edge
 */
export function buildSparklinePointString(instrumentId, positiveTrend) {
  const seed = (instrumentId || 1) % 9001;
  const w = 100;
  const h = 36;
  const n = 16;
  const trend = positiveTrend ? -1 : 1;
  const parts = [];
  for (let i = 0; i <= n; i += 1) {
    const x = (i / n) * w;
    const wave =
      Math.sin(seed / 700 + i * 0.85) * 7 +
      Math.cos(i * 0.4 + seed / 2500) * 4.5;
    const base = h * 0.58 + trend * (i / n) * (h * 0.26);
    const y = Math.min(h - 3, Math.max(3, base + wave));
    parts.push(`${x.toFixed(1)},${y.toFixed(1)}`);
  }
  return parts.join(' ');
}
